import { createSelector } from '@reduxjs/toolkit';

import { getImmutableCompatible } from 'src/utils/immutableUtils';

import { ERRORS_LIMIT } from './constants';
import { isEmptySearchSelector } from '../store/emptySearch/selectors';
import { isEmptyHotelsListSelector } from '../store/hotels/selectors';
import type { SearchStatusState } from './slice';

const name = 'searchStatus';

const searchStatusState = (state): SearchStatusState =>
  getImmutableCompatible(state, name);

export const isAwaitingFiltration = createSelector(
  [searchStatusState],
  (searchStatus) => searchStatus.awaitFiltration,
);
export const hasResults = createSelector(
  [searchStatusState],
  (searchStatus) => searchStatus.hasResults,
);
export const hasNewResults = createSelector(
  [searchStatusState],
  (searchStatus) => searchStatus?.hasMore || false,
);
export const sizeSearchSelector = createSelector(
  [searchStatusState],
  (searchStatus) => searchStatus.size,
);
export const getSearchProgress = createSelector(
  [searchStatusState],
  (searchStatus) => searchStatus.searchProgress,
);
export const getOperatorsStatus = createSelector(
  [searchStatusState],
  (searchStatus) => {
    const { operatorsStatus } = searchStatus;
    const operatorsValues = Object.values(operatorsStatus);
    return operatorsValues;
  },
);
// Поиск завершен на сервере.
export const isSearchDone = createSelector(
  [searchStatusState],
  (searchStatus) => searchStatus?.isDone || false,
);
// Поиск завершен.
export const isSearchCompleteSelector = createSelector(
  [isSearchDone, hasNewResults],
  (isSearchDoneParam, hasNewResultsParam): boolean =>
    isSearchDoneParam && !hasNewResultsParam,
);
// Флаг показа скелетонов на поиске
export const isShownLoadingSelector = createSelector(
  [isAwaitingFiltration, isEmptyHotelsListSelector, isEmptySearchSelector],
  (awaitFiltration, noResults, isEmptySearch): boolean =>
    (noResults && !isEmptySearch) || awaitFiltration,
);

export const isSearchProgressCompletedSelector = createSelector(
  getSearchProgress,
  (searchProgress) => searchProgress === 100,
);

export const isSearchByFiltersSelector = createSelector(
  [searchStatusState],
  (searchStatus) => searchStatus.isSearchByFilters,
);

/**
 * Пришли первые результаты из ggh
 */
export const firstResultsFetchedSelector = createSelector(
  [searchStatusState],
  (searchStatus) => searchStatus.firstResultsFetched,
);

/**
 * Количество ошибок при вызове get_grouped_hotels
 */
export const searchStatusErrorsCountSelector = createSelector(
  [searchStatusState],
  (state): number => getImmutableCompatible(state, 'errorsCount'),
);

/**
 * Количество ошибок при вызове get_grouped_hotels достигло лимита
 */
export const enreachErrorsLimitSelector = createSelector(
  [searchStatusErrorsCountSelector],
  (errorsCount): boolean => errorsCount >= ERRORS_LIMIT,
);
